import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

/**
 */

/**
 * @deprecated 是否是企业微信端 (**企微 + 企微私有化**)
 *
 * 使用以下写法替代:
 * ```
 * if (__IS_WECOM__) {}
 * ```
 */
export const IS_ENTERPRISE = appConfigInstance.getConfig('domain') === 'wecom' || appConfigInstance.getConfig('domain') === 'private-wecom';

/**
 * @deprecated 是否是C端;
 *
 * 使用以下写法替代:
 * ```
 * if (!__IS_WECOM__) {}
 * ```
 */
export const IS_TOC = appConfigInstance.getConfig('domain') === 'toc';

/**
 * 是否是企微私有化
 */
export const IS_PRIVATE_WECOM = process.env.DOMAIN === 'private-wecom';


/**
 * 自定义资源
 */
export const CUSTOM = {
    ADDON: {
        /**
         * 插件 IFrame 地址前缀
         */
        IFRAME_URL: appConfigInstance.getConfig('custom.addon.iframeUrl') as string,
    },
    ATTACHMENT: {
        /**
         * 音频附件默认图标
         */
        DEFAULT_AUDIO_IMAGE: appConfigInstance.getConfig('custom.attachment.defaultAudioImage') as string,
        /**
         * 音频附件默认图标
         */
        DEFAULT_VIDEO_IMAGE: appConfigInstance.getConfig('custom.attachment.defaultVideoImage') as string,
    },
    AUTH: {
        /**
         * 跳转QQ小程序域名
         */
        QMP_PERM_URL: appConfigInstance.getConfig('custom.auth.qmpPermUrl') as string,
        /**
         * 微信自动登录时使用开放平台路径组合跳转
         */
        WX_CODE_URL: appConfigInstance.getConfig('custom.auth.wxCodeUrl') as string,
        /**
         * b端+ qq 域名，非 qq 域名需要经过 scenario 中转跳转
         */
        QQ_URL: appConfigInstance.getConfig('custom.auth.qqUrl') as string,
    },
    /**
     * CDN 域名
     */
    CDN: {
        /**
         * 老版图片 CDN 域名
         */
        QPIC: appConfigInstance.getConfig('custom.cdn.qpic') as string,
    },
    /**
     * 复制粘贴相关
     */
    COPYPASTE: {
        /**
         * 默认占位图片地址
         */
        PLACEHOLDER: {
            '1X': appConfigInstance.getConfig('custom.copypaste.placeholder.normal') as string,
            '2X': appConfigInstance.getConfig('custom.copypaste.placeholder.retina') as string,
        },
    },
    DC: {
        /**
         * DC组件资源加载列表
         */
        PREFIX: appConfigInstance.getConfig('custom.dc.prefix') as string,
    },
    /**
     * 各品类 Favicon
     */
    FAVICON: {
        WORD: appConfigInstance.getConfig('custom.favicon.word') as string,
        PDF: appConfigInstance.getConfig('custom.favicon.pdf') as string,
        SLIDE: appConfigInstance.getConfig('custom.favicon.slide') as string,
    },
    IMAGE: {
        /**
         * IE下的格式刷光标图样
         */
        BRUSH_IE: appConfigInstance.getConfig('custom.image.brushIE') as string,
        /**
         * 默认头像图片
         */
        DEFAULT_AVATAR: appConfigInstance.getConfig('custom.image.defaultAvatar') as string,
        /**
         * 填充里的默认图像
         */
        DEFAULT_FILL_IMAGE: appConfigInstance.getConfig('custom.image.defaultFillImage') as string,
        /**
         * B端+ B端边写边聊默认头像图标
         */
        DEFAULT_CONVERSATION_IMG: appConfigInstance.getConfig('custom.image.defaultConversationImg') as string,
    },
    LIBRARY: {
        /**
         * wabt sdk
         * https://docs.idqqimg.com/pub/js/abt_sdk.min.js
         */
        WABT: appConfigInstance.getConfig('custom.library.wabt') as string,
    },
    LINK: {
        /**
         * 手机帮助中心, 默认配置是 PC 的, 不确定是否通用
         */
        HELP_CENTER: appConfigInstance.getConfig('custom.link.helpCenter') as string,
        /**
         * 文件删除还原url
         * C端 https://docs.qq.com/desktop/trash
         * B端 https://doc.weixin.qq.com/home/recycle
         */
        RECYCLE: appConfigInstance.getConfig('custom.link.recycle') as string,
        /**
         * b端+ 手机端微文档帮助与反馈入口, 默认配置中有相似的, 但不一样，没有复用
         */
        MINI_FEEDBACK: appConfigInstance.getConfig('custom.link.miniFeedback') as string,
    },
    /**
     * 腾讯会议的交互
     */
    MEETING: {
        TEST: appConfigInstance.getConfig('custom.meeting.test') as string,
        PRERELEASE: appConfigInstance.getConfig('custom.meeting.preRelease') as string,
        RELEASE: appConfigInstance.getConfig('custom.meeting.release') as string,
    },
    RAINBOW: {
        URL: appConfigInstance.getConfig('custom.rainbow.url') as string,
    },
    SENTRY: {
        /**
         * C端: 'https://ca9f1764efdd427097f3a1822a127cbf@report.url.cn/sentry/942'
         * B端: 'https://3253a76514e84ce8be4c13309296e3d9@report.url.cn/sentry/3656'
         */
        DSN: appConfigInstance.getConfig('custom.sentry.dsn') as string,
    },
    TAPD: {
        /**
         * 提 bug 单到 tapd 的地址
         */
        CREATE_URL: appConfigInstance.getConfig('custom.tapd.createUrl') as string,
    },
    WEDRIVE: {
        /**
         * b端+ 微盘路径前缀，打开文档在微盘中的所在文件夹用
         */
        PREFIX: appConfigInstance.getConfig('custom.wedrive.prefix') as string,
    },
};

export const RUNTIME = {
    /**
     * 形如：docs.qq.com
     * 默认值 window.location.hostname
     */
    DOMAIN_NAME: (appConfigInstance.getConfig('runtime.domainName') || location?.hostname) as string,
    /**
     * 形如：//docs.qq.com/
     */
    API_ROOT: (appConfigInstance.getConfig('runtime.apiRoot') || `//${location?.hostname}/`) as string,

    /**
     * 通用上报域名
     */
    REPORT_CGI_MAP: {
        /**
         * 形如 '//report.idqqimg.com/node_b/zzsreport'
         */
        ZZS_REPORT: appConfigInstance.getConfig('runtime.reportCgiMap.zzsReport') as string,
    },

    LIBRARY: {
        /**
         * 微信SDK，版本1.6.0
         */
        WX_JS_SDK_1_6_0: appConfigInstance.getConfig('runtime.library.TENCENT_DOCS_LIBRARY__jweixin_1_6_0') as string,
        /**
         * QQ SDK，版本1.0.0
         */
        QQ_JS_SDK_1_0_0: appConfigInstance.getConfig('runtime.library.TENCENT_DOCS_LIBRARY__qqjssdk_1_0_0') as string,
        /**
         * WEBLOG
         */
        WEBLOG_BROWSER: appConfigInstance.getConfig('runtime.library.TENCENT_DOCS_LIBRARY__weblog_tdoc_browser') as string,
    },
};

export const LINK = {
    /**
     * 帮助中心
     */
    HELP_CENTER: appConfigInstance.getConfig('links.helpCenter') as string,
    /**
     * 举报
     */
    REPORT: appConfigInstance.getConfig('links.report') as string,
    /**
     * 反馈
     * c: https://support.qq.com/products/28096
     * c客户端: https://support.qq.com/product/406904
     * b: https://support.qq.com/products/111603
     */
    FEEDBACK: appConfigInstance.getConfig('links.feedback') as string,
    FEEDBACK_FOR_APP: appConfigInstance.getConfig('links.feedbackForApp') as string,
    /**
     * 申诉页
     */
    APPEAL_PAGE: appConfigInstance.getConfig('links.appealPage') as string,
    /**
     * 侵权指引入口
     */
    INFRINGEMENT_GUIDE_LINES: appConfigInstance.getConfig('links.infringementGuidelines') as string,
};

/**
 * 租户信息
 */
export const TENANT_CONFIG = {
    /**
     * 租户名
     */
    TENANT_NAME: appConfigInstance.getConfig('tenantConfig.tenantName') as string,
    /**
     * 租户文档名
     */
    TENANT_DOC_NAME: appConfigInstance.getConfig('tenantConfig.tenantDocName') as string,
    /**
     * 租户相关 logo 信息
     */
    TENANT_LOGO: {
        /**
         * 黑色 logo svg 地址
         */
        SVG_BLACK: appConfigInstance.getConfig('tenantConfig.tenantLogo.SVGBlack') as string,
        /**
         * 彩色 logo svg 地址
         */
        SVG_COLOR: appConfigInstance.getConfig('tenantConfig.tenantLogo.SVGColor') as string,
    },
};
